import React, {useState} from "react";
import {Descriptions, Collapse} from "antd";
import {
    CollapseContainer,
    MapContainer,
    OrderMergeContainer
} from "../../subCompanyDetail/scDetailStyles";
import {
    ResponsiveDescriptions,
    DetailHeaderRow,
    DetailTitleBlock,
    DetailTitleName,
    DetailActionsRow,
    InfoCardsSection,
    InfoCardsRow,
    InfoCard,
    InfoCardLabel,
    InfoCardValue,
    AvailableCouriersWrap
} from "./styles/styled";
import {Link} from "react-router-dom";
import {SingleMarkerMap} from "../../../_defaultComponents/SingleMarkerMap/SingleMarkerMap";
import {ConditionalTooltip} from "../../../_defaultComponents/ConditionalTooltip/ConditionalTooltip";
import {CustomButton} from "../../../_defaultComponents/CustomButton/CustomButton";
import moment from "moment";
import {EditOutlined, ShopOutlined, LoadingOutlined, LinkOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import {useStore, useFetch} from "@vigo/hooks";
import {ChangeSubcompanyOnboardingStatusInput} from "../../../_defaultComponents/ChangeSubcompanyOnboardingStatusInput/ChangeSubcompanyOnboardingStatusInput";
import {CourierLink} from "../../../_defaultComponents/CourierLink/CourierLink";
import {StyledLinkButton} from "../../../_defaultComponents/StyledLinkButton/StyledLinkButton";
import {SubCompanyPaymentContractDetail} from "../../../_defaultComponents/SubCompanyPaymentContractsTable/SubCompanyPaymentContractDetail/SubCompanyPaymentContractDetail";
import {useActiveContractDetail} from "../../../_defaultComponents/SubCompanyPaymentContractsTable/useActiveContractDetail";
import {
    getCreditModeLabel,
    invoiceCutPeriodOptions,
    managerCompanyOptions
} from "constants/constants";

export const SubCompanyDetailTab = ({subCompanyId, subCompany, recall = () => {}}) => {
    const {Panel} = Collapse;
    const stores = useStore();
    const isAgency = stores.meStore.checkRole("isAgency");
    const {t, i18n} = useTranslation(["subcompanyDetail", "courierTypes"]);
    const {
        contract: activeContractDetail,
        loadingSubCompanyId: activeContractLoadingSubCompanyId,
        open: openActiveContractDetail,
        close: closeActiveContractDetail
    } = useActiveContractDetail();
    const isActiveContractLoading = activeContractLoadingSubCompanyId === subCompanyId;
    // Acente için sözleşme yoksa link ikonu hiç gösterilmez ve tıklanamaz; sözleşme
    // varsa açılırken ikon yerine loading gösterilir.
    const isAgencyContractClickable =
        isAgency && subCompany?.hasActiveContract && !isActiveContractLoading;
    const activeContractIcon = !isAgency ? (
        <LinkOutlined />
    ) : !subCompany?.hasActiveContract ? null : isActiveContractLoading ? (
        <LoadingOutlined />
    ) : (
        <LinkOutlined />
    );

    const [dedicatedCouriersLoading, setDedicatedCouriersLoading] = useState(false);
    const [dedicatedCouriers, setDedicatedCouriers] = useState(undefined);
    const onAssignedCouriersPanelToggle = async activePanels => {
        if (!activePanels || activePanels.length === 0) {
            return;
        }
        if (dedicatedCouriers) {
            return;
        }

        setDedicatedCouriersLoading(true);
        const getDedicatedCourierResponse = await stores.courierStore.getDedicatedCourier({
            companyId: subCompanyId,
            subCompanyId: subCompanyId
        });

        if (!getDedicatedCourierResponse || !getDedicatedCourierResponse?.couriers) {
            setDedicatedCouriersLoading(false);
            return;
        }

        setDedicatedCouriers(getDedicatedCourierResponse?.couriers);
        setDedicatedCouriersLoading(false);
    };

    const [loadingPool, poolData] = useFetch({
        fetchFn: stores.poolStore.getPoolBySubCompanyId.bind(null, {
            subCompanyId: subCompanyId
        }),
        dependencies: [subCompanyId],
        initialCall: !!subCompanyId
    });

    return (
        <>
            <ResponsiveDescriptions>
                <Descriptions
                    column={{xs: 1, sm: 1, md: 2}}
                    title={
                        <>
                            <DetailHeaderRow>
                                <DetailTitleBlock>
                                    <DetailTitleName>{subCompany?.name}</DetailTitleName>
                                </DetailTitleBlock>
                                <DetailActionsRow>
                                    {stores.meStore.checkRole("changeSubcompanyOnboardingStatus") &&
                                    subCompany ? (
                                        <ChangeSubcompanyOnboardingStatusInput
                                            subCompany={subCompany}
                                            recall={recall}
                                        />
                                    ) : null}
                                    {!isAgency && stores.meStore.checkRole("updateCompany") && (
                                        <ConditionalTooltip
                                            text={t(
                                                "subcompanyDetail.disabledUpdateSubcompanyTooltip",
                                                {
                                                    ns: "subcompanyDetail"
                                                }
                                            )}
                                            condition={subCompany.disabled}
                                            child={
                                                <Link
                                                    to={{
                                                        pathname:
                                                            "/companies/update-sub-company/" +
                                                            subCompany._id
                                                    }}
                                                >
                                                    <CustomButton
                                                        type="primary"
                                                        disabled={subCompany.disabled}
                                                        icon={<EditOutlined />}
                                                        style={{marginTop: "0px"}}
                                                    />
                                                </Link>
                                            }
                                        />
                                    )}
                                </DetailActionsRow>
                            </DetailHeaderRow>

                            <InfoCardsSection>
                                <InfoCardsRow>
                                    <InfoCard>
                                        <InfoCardLabel>Firma</InfoCardLabel>
                                        <InfoCardValue>
                                            <StyledLinkButton
                                                to={
                                                    subCompany?.companyId
                                                        ? `/companies/${subCompany?.companyId}`
                                                        : subCompanyId
                                                        ? `/companies/${subCompanyId}`
                                                        : null
                                                }
                                                disabled={
                                                    !subCompany?.companyId ||
                                                    !stores.meStore.checkRole("isAdmin")
                                                }
                                                icon={<LinkOutlined />}
                                                style={{
                                                    fontSize: "14px",
                                                    fontWeight: "500",
                                                    maxWidth: "100%",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                    display: "block"
                                                }}
                                            >
                                                {subCompany?.company?.companyName || "-"}
                                            </StyledLinkButton>
                                        </InfoCardValue>
                                    </InfoCard>
                                    <InfoCard>
                                        <InfoCardLabel>Çalışma Şekli</InfoCardLabel>
                                        <InfoCardValue>
                                            <StyledLinkButton
                                                to={
                                                    subCompany?._id &&
                                                    subCompany?.subCompanyWorkType === "pool"
                                                        ? `/pools/${poolData._id}`
                                                        : null
                                                }
                                                disabled={
                                                    !subCompany?._id ||
                                                    subCompany?.subCompanyWorkType !== "pool" ||
                                                    !stores.meStore.checkRole("isAdmin")
                                                }
                                                icon={
                                                    subCompany?._id &&
                                                    subCompany?.subCompanyWorkType === "pool" ? (
                                                        <LinkOutlined />
                                                    ) : null
                                                }
                                                style={{
                                                    fontSize: "14px",
                                                    fontWeight: "500",
                                                    maxWidth: "100%",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                    display: "block"
                                                }}
                                            >
                                                {subCompany?.subCompanyWorkType === "dedicated"
                                                    ? "Dedike"
                                                    : poolData?.name
                                                    ? `Havuz | ${poolData.name}`
                                                    : "Havuz"}
                                            </StyledLinkButton>
                                        </InfoCardValue>
                                    </InfoCard>
                                    <InfoCard>
                                        <InfoCardLabel>Kredi Modu</InfoCardLabel>
                                        <InfoCardValue>
                                            <StyledLinkButton
                                                to={null}
                                                style={{
                                                    fontSize: "14px",
                                                    fontWeight: "500",
                                                    display: "block"
                                                }}
                                            >
                                                {getCreditModeLabel(subCompany?.creditMode)}
                                            </StyledLinkButton>
                                        </InfoCardValue>
                                    </InfoCard>
                                    {subCompany?.creditMode === "onlyLog" && (
                                        <InfoCard>
                                            <InfoCardLabel>Fatura Kesim Dönemi</InfoCardLabel>
                                            <InfoCardValue>
                                                <StyledLinkButton
                                                    to={null}
                                                    style={{
                                                        fontSize: "14px",
                                                        fontWeight: "500",
                                                        display: "block"
                                                    }}
                                                >
                                                    {invoiceCutPeriodOptions.find(
                                                        o => o.value === subCompany?.invoicePeriod
                                                    )?.label || "-"}
                                                </StyledLinkButton>
                                            </InfoCardValue>
                                        </InfoCard>
                                    )}
                                    <InfoCard>
                                        <InfoCardLabel>Yönetici Firma</InfoCardLabel>
                                        <InfoCardValue>
                                            <StyledLinkButton
                                                to={null}
                                                style={{
                                                    fontSize: "14px",
                                                    fontWeight: "500",
                                                    display: "block"
                                                }}
                                            >
                                                {managerCompanyOptions.find(
                                                    o => o.value === subCompany?.managerCompany
                                                )?.name || "-"}
                                            </StyledLinkButton>
                                        </InfoCardValue>
                                    </InfoCard>
                                    <InfoCard>
                                        <InfoCardLabel>Aktif Sözleşme</InfoCardLabel>
                                        <InfoCardValue>
                                            <StyledLinkButton
                                                to={
                                                    isAgency
                                                        ? null
                                                        : `/sub-company/payment-contract/${subCompanyId}`
                                                }
                                                onClick={
                                                    isAgencyContractClickable
                                                        ? () =>
                                                              openActiveContractDetail(subCompanyId)
                                                        : undefined
                                                }
                                                icon={activeContractIcon}
                                                style={{
                                                    fontSize: "14px",
                                                    fontWeight: "500",
                                                    display: "block",
                                                    cursor: isAgency
                                                        ? subCompany?.hasActiveContract
                                                            ? "pointer"
                                                            : "default"
                                                        : undefined
                                                }}
                                            >
                                                {subCompany?.hasActiveContract ? "Var" : "Yok"}
                                            </StyledLinkButton>
                                        </InfoCardValue>
                                    </InfoCard>
                                </InfoCardsRow>
                            </InfoCardsSection>

                            {stores.meStore.checkRole("isAdmin") && subCompany?.company?._id && (
                                <AvailableCouriersWrap>
                                    <StyledLinkButton
                                        to={`/available-couriers?companyId=${
                                            subCompany?.company?._id
                                        }&subcompanyId=${subCompany?._id}&courierType=motorCourier${
                                            poolData?._id ? `&pool=${poolData._id}` : ""
                                        }&distance=100000`}
                                        icon={<LinkOutlined />}
                                        style={{
                                            fontSize: "16px",
                                            fontWeight: "500",
                                            display: "block"
                                        }}
                                    >
                                        Müsait Kuryeler
                                    </StyledLinkButton>
                                </AvailableCouriersWrap>
                            )}
                        </>
                    }
                    bordered
                >
                    <Descriptions.Item span={1} label="Tabela Adı">
                        {subCompany.signName || "-"}
                    </Descriptions.Item>
                    <Descriptions.Item label={t("fields.testUser", {ns: "common"})}>
                        {subCompany.isTestUser
                            ? t("other.yes", {ns: "common"})
                            : t("other.no", {ns: "common"})}
                    </Descriptions.Item>
                    <Descriptions.Item span={1} label="Firma Kategorisi">
                        {subCompany.category || "-"}
                    </Descriptions.Item>
                    <Descriptions.Item span={1} label="Tahsilat Miktarı">
                        {subCompany.collectionAmount ? subCompany.collectionAmount + " TL" : "-"}
                    </Descriptions.Item>
                    <Descriptions.Item span={1} label="Maksimum Mesafe">
                        {subCompany.maxAcceptableDistance
                            ? subCompany.maxAcceptableDistance + " km"
                            : "- km"}
                    </Descriptions.Item>
                    <Descriptions.Item span={1} label={t("fields.companyActivity", {ns: "common"})}>
                        {subCompany.disabled
                            ? t("other.inactive", {ns: "common"})
                            : t("other.active", {ns: "common"})}
                    </Descriptions.Item>
                    <Descriptions.Item span={1} label="Alt Firma Onay Durumu">
                        {subCompany?.onboardingStatus &&
                        subCompany?.onboardingStatus !== "undefined"
                            ? t(
                                  `fields.subCompanyOnboardingOptions.${subCompany?.onboardingStatus}`,
                                  {
                                      ns: "common"
                                  }
                              )
                            : "-"}
                    </Descriptions.Item>
                    <Descriptions.Item span={1} label={t("fields.subCompanyCode", {ns: "common"})}>
                        {subCompany.subCompanyCode &&
                            `${subCompany.subCompanyCode.companyCode}${(
                                "00" + subCompany.subCompanyCode.cityCode
                            ).slice(-2)}${("0000" + subCompany.subCompanyCode.code).slice(-4)}`}
                    </Descriptions.Item>
                    <Descriptions.Item span={1} label={t("fields.createdBy", {ns: "common"})}>
                        {subCompany.createdBy || t("other.unspecified", {ns: "common"})}
                    </Descriptions.Item>
                    <Descriptions.Item span={2} label={t("fields.createdDate", {ns: "common"})}>
                        {subCompany.createdAt
                            ? moment(subCompany.createdAt)
                                  .locale(i18n.resolvedLanguage || "tr")
                                  .format("DD-MM-YYYY HH:mm:ss")
                            : t("other.unspecified", {ns: "common"})}
                    </Descriptions.Item>
                    <Descriptions.Item span={1} label={t("fields.updatedBy", {ns: "common"})}>
                        {subCompany.updatedBy || t("other.unspecified", {ns: "common"})}
                    </Descriptions.Item>
                    <Descriptions.Item
                        span={1}
                        label={t("subcompanyDetail.fields.updatedAt", {
                            ns: "subcompanyDetail"
                        })}
                    >
                        {subCompany.updatedAt
                            ? moment(subCompany.updatedAt)
                                  .locale(i18n.resolvedLanguage || "tr")
                                  .format("DD-MM-YYYY HH:mm:ss")
                            : t("other.unspecified", {ns: "common"})}
                    </Descriptions.Item>
                    <Descriptions.Item span={1} label="Manuel Atama">
                        {subCompany.isAllocateClosed ? "Açık" : "Kapalı"}
                    </Descriptions.Item>
                    <Descriptions.Item span={1} label={t("fields.city", {ns: "common"})}>
                        {subCompany.city}
                    </Descriptions.Item>
                    <Descriptions.Item span={1} label={t("fields.county", {ns: "common"})}>
                        {subCompany.city && subCompany.county}
                    </Descriptions.Item>
                    <Descriptions.Item span={1} label={"Bölge Müdürlüğü"}>
                        {subCompany.zoneInfo?.zoneManagementName || "-"}
                    </Descriptions.Item>
                    <Descriptions.Item span={1} label={"Bölge"}>
                        {subCompany.zoneInfo?.zoneName || "-"}
                    </Descriptions.Item>
                    <Descriptions.Item span={2} label={t("fields.address", {ns: "common"})}>
                        {subCompany.address}
                    </Descriptions.Item>
                    <Descriptions.Item
                        span={1}
                        label={t("fields.authorizedPerson", {ns: "common"})}
                    >
                        {subCompany.authorizedPerson}
                    </Descriptions.Item>
                    <Descriptions.Item span={1} label={t("fields.authorizedID", {ns: "common"})}>
                        {subCompany.authorizedID}
                    </Descriptions.Item>
                    <Descriptions.Item span={1} label={t("fields.authorizedPhone", {ns: "common"})}>
                        {subCompany.authorizedPhone}
                    </Descriptions.Item>
                    <Descriptions.Item span={1} label={t("fields.authorizedEmail", {ns: "common"})}>
                        {subCompany.authorizedEmail}
                    </Descriptions.Item>
                    <Descriptions.Item span={2} label={t("fields.uniqueKey", {ns: "common"})}>
                        {subCompany.uniqueKey}
                    </Descriptions.Item>
                    <Descriptions.Item
                        span={2}
                        label={t("fields.allowedOrderProviders", {ns: "common"})}
                    >
                        {subCompany.allowedOrderProviders?.join()}
                    </Descriptions.Item>
                    <Descriptions.Item span={2} label={"Kasa Yazılım Sistemi"}>
                        {subCompany?.cashRegisterMethod ? subCompany.cashRegisterMethod : "-"}
                    </Descriptions.Item>
                    <Descriptions.Item span={2} label={"External ID"}>
                        {subCompany?.externalId ? subCompany.externalId : "-"}
                    </Descriptions.Item>
                    <Descriptions.Item span={1} label={"Vergi Numarası"}>
                        {subCompany?.bill?.taxNumber || "-"}
                    </Descriptions.Item>
                </Descriptions>
            </ResponsiveDescriptions>
            {stores.meStore.role == "admin" &&
                subCompany?.options?.merge?.map((mergeOptions, index) =>
                    mergeOptions.isActive ? (
                        <ResponsiveDescriptions key={"OrderMergeContainer" + index}>
                            <OrderMergeContainer
                                column={{xs: 1, sm: 1, md: 3}}
                                size="small"
                                bordered
                            >
                                <Descriptions.Item
                                    span={3}
                                    label={t("fields.courierType", {ns: "common"})}
                                >
                                    {mergeOptions?.courierType === "motorCourier"
                                        ? t("longForm.motorCourier", {ns: "courierTypes"})
                                        : t("longForm.carCourier", {ns: "courierTypes"})}
                                </Descriptions.Item>
                                <Descriptions.Item
                                    label={t("fields.mergeOptions.orderMerge.label", {
                                        ns: "common"
                                    })}
                                >
                                    {mergeOptions?.isActive
                                        ? t("other.active", {ns: "common"})
                                        : t("other.passive", {ns: "common"})}
                                </Descriptions.Item>
                                <Descriptions.Item
                                    label={t("fields.mergeOptions.clickToDoorTime.label", {
                                        ns: "common"
                                    })}
                                >
                                    {mergeOptions?.clickToDoorTime +
                                        " " +
                                        t("units.minute.long", {ns: "common"})}
                                </Descriptions.Item>
                                <Descriptions.Item
                                    label={t("fields.mergeOptions.prepTime.label", {
                                        ns: "common"
                                    })}
                                >
                                    {mergeOptions?.prepTime +
                                        " " +
                                        t("units.minute.long", {ns: "common"})}
                                </Descriptions.Item>
                                <Descriptions.Item
                                    label={t("fields.mergeOptions.prepTimeBufferPercent.label", {
                                        ns: "common"
                                    })}
                                >
                                    {"%" + mergeOptions?.prepTimeBufferPercent}
                                </Descriptions.Item>
                                <Descriptions.Item
                                    label={t("fields.mergeOptions.handOverTime.label", {
                                        ns: "common"
                                    })}
                                >
                                    {mergeOptions?.handOverTime +
                                        " " +
                                        t("units.minute.long", {ns: "common"})}
                                </Descriptions.Item>
                                <Descriptions.Item
                                    label={t("fields.mergeOptions.mergeMaxOrder.label", {
                                        ns: "common"
                                    })}
                                >
                                    {mergeOptions?.maxOrder +
                                        " " +
                                        t("units.piece.long", {ns: "common"})}
                                </Descriptions.Item>
                                <Descriptions.Item
                                    label={t(
                                        "fields.mergeOptions.mergeWithOtherVehicleTypes.label",
                                        {
                                            ns: "common"
                                        }
                                    )}
                                >
                                    {mergeOptions?.mergeWithOtherTypes
                                        ? t("other.active", {ns: "common"})
                                        : t("other.passive", {ns: "common"})}
                                </Descriptions.Item>
                                <Descriptions.Item
                                    label={t("fields.mergeOptions.mergeWithOtherCompanies.label", {
                                        ns: "common"
                                    })}
                                >
                                    {mergeOptions?.mergeWithOtherCompanies
                                        ? t("other.active", {ns: "common"})
                                        : t("other.passive", {ns: "common"})}
                                </Descriptions.Item>
                                <Descriptions.Item
                                    label={t("fields.mergeOptions.maxPickup.label", {
                                        ns: "common"
                                    })}
                                >
                                    {mergeOptions?.maxPickup + " adet"}
                                </Descriptions.Item>
                            </OrderMergeContainer>
                        </ResponsiveDescriptions>
                    ) : null
                )}
            {stores.meStore.role == "admin" && subCompany?.options?.queue?.isActive ? (
                <ResponsiveDescriptions>
                    <OrderMergeContainer column={{xs: 1, sm: 1, md: 3}} size="small" bordered>
                        <Descriptions.Item
                            label={t("fields.queueOptions.orderQueue.label", {
                                ns: "common"
                            })}
                        >
                            {subCompany?.options?.queue?.isActive
                                ? t("other.active", {ns: "common"})
                                : t("other.passive", {ns: "common"})}
                        </Descriptions.Item>
                        <Descriptions.Item
                            label={t("fields.queueOptions.maxOrderCount.label", {
                                ns: "common"
                            })}
                        >
                            {subCompany?.options?.queue?.maxCount}
                        </Descriptions.Item>
                        <Descriptions.Item
                            label={t("fields.queueOptions.maxWaitingTime.label", {
                                ns: "common"
                            })}
                        >
                            {subCompany?.options?.queue?.maxWaitingTime +
                                " " +
                                t("units.minute.long", {ns: "common"})}
                        </Descriptions.Item>
                        <Descriptions.Item
                            label={t("fields.queueOptions.thresholdCount.label", {
                                ns: "common"
                            })}
                        >
                            {"%" + subCompany?.options?.queue?.thresholdCount}
                        </Descriptions.Item>
                        <Descriptions.Item
                            label={t("fields.queueOptions.thresholdTime.label", {
                                ns: "common"
                            })}
                        >
                            {subCompany?.options?.queue?.thresholdTime +
                                " " +
                                t("units.minute.long", {ns: "common"})}
                        </Descriptions.Item>
                    </OrderMergeContainer>
                </ResponsiveDescriptions>
            ) : null}
            <ResponsiveDescriptions>
                <OrderMergeContainer column={{xs: 1, sm: 1, md: 3}} size="small" bordered>
                    <Descriptions.Item label="En Eski Siparişi Alma Zorunluluğu">
                        {subCompany?.options?.jokerLeadOrder?.isActive
                            ? t("other.active", {ns: "common"})
                            : t("other.passive", {ns: "common"})}
                    </Descriptions.Item>
                    <Descriptions.Item label="Süre">
                        {(subCompany?.options?.jokerLeadOrder?.thresholdMinutes || 0) +
                            " " +
                            t("units.minute.long", {ns: "common"})}
                    </Descriptions.Item>
                </OrderMergeContainer>
            </ResponsiveDescriptions>

            {stores.meStore.role == "admin" ? (
                <>
                    <ResponsiveDescriptions>
                        <OrderMergeContainer column={{xs: 1, sm: 1, md: 3}} size="small" bordered>
                            <Descriptions.Item
                                label={t("fields.forceCourierNotificationDistance", {
                                    ns: "common"
                                })}
                            >
                                {subCompany?.forceCourierNotificationDistance
                                    ? subCompany?.forceCourierNotificationDistance +
                                      " " +
                                      t("units.meter.long", {ns: "common"})
                                    : "-"}
                            </Descriptions.Item>
                            <Descriptions.Item
                                label={t("fields.isPoolIntensityAlertActive", {
                                    ns: "common"
                                })}
                            >
                                {subCompany?.isPoolIntensityAlertActive
                                    ? t("other.active", {ns: "common"})
                                    : t("other.passive", {ns: "common"})}
                            </Descriptions.Item>
                        </OrderMergeContainer>
                    </ResponsiveDescriptions>

                    <ResponsiveDescriptions>
                        <OrderMergeContainer column={{xs: 1, sm: 1, md: 3}} size="small" bordered>
                            <Descriptions.Item
                                label={t("fields.addReturnProduct", {
                                    ns: "common"
                                })}
                            >
                                {subCompany?.options?.codPayment?.addReturnProduct
                                    ? t("other.active", {ns: "common"})
                                    : t("other.passive", {ns: "common"})}
                            </Descriptions.Item>
                        </OrderMergeContainer>
                    </ResponsiveDescriptions>
                </>
            ) : null}

            <CollapseContainer>
                <Collapse onChange={e => onAssignedCouriersPanelToggle(e)}>
                    <Panel
                        header={t("subcompanyDetail.assignedCouriers", {
                            ns: "subcompanyDetail"
                        })}
                    >
                        {dedicatedCouriersLoading ? (
                            <LoadingOutlined />
                        ) : dedicatedCouriers?.length > 0 ? (
                            dedicatedCouriers.map(courier => (
                                <div key={courier.id}>
                                    <CourierLink target="_blank" to={`/couriers/${courier.id}`}>
                                        {courier.fullname}
                                    </CourierLink>
                                </div>
                            ))
                        ) : (
                            t("subcompanyDetail.unassignedCourier", {
                                ns: "subcompanyDetail"
                            })
                        )}
                    </Panel>
                </Collapse>
            </CollapseContainer>

            <MapContainer>
                <SingleMarkerMap
                    center={{
                        lat: subCompany?.location?.latitude,
                        lng: subCompany?.location?.longitude
                    }}
                    icon={<ShopOutlined />}
                />
            </MapContainer>

            {activeContractDetail && (
                <SubCompanyPaymentContractDetail
                    subCompanyPaymentContract={activeContractDetail}
                    visible={true}
                    onClose={closeActiveContractDetail}
                />
            )}
        </>
    );
};
